import DOMPurify from "dompurify";

export const getPriceQueryParams = (searchParams, key, value) => {
    const hasValueInParam = searchParams.has(key);
  
    if (value && hasValueInParam) {
      searchParams.set(key, value);
    } else if (value) {
      searchParams.append(key, value);
    } else if (hasValueInParam) {
      searchParams.delete(key);
    }
  
    return searchParams;
  };
  
  export const caluclateOrderCost = (cartItems) => {
    const itemsPrice = cartItems?.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
  
    const shippingPrice = itemsPrice > 200 ? 0 : 25;
    const taxPrice = Number((0.15 * itemsPrice).toFixed(2));
    const totalPrice = (itemsPrice + shippingPrice + taxPrice).toFixed(2);
  
    return {
      itemsPrice: Number(itemsPrice).toFixed(2),
      shippingPrice,
      taxPrice,
      totalPrice,
    };
  };

  export const formatRelativeDate = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
  
    if (days > 7)
      return new Date(date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    if (days >= 1) return days === 1 ? "Yesterday" : `${days} days ago`;
    if (hours >= 1) return `${hours}h ago`;
    if (minutes >= 1) return `${minutes}m ago`;
    return "Just now";
  };


  export const getReadingTime = (html) => {
    if (!html) return 1;
    const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
    const words = clean.trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(words / 200));
  };